import * as React from 'react'

import { Button, Form } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import TextEditor, { type EditorHandle } from 'modules/core/components/TextEditor'
import i18n from 'modules/core/lib/i18n'

interface Props {
  submitting: boolean
  messageField: Field
  onSubmit: () => void
  onFileChange: (files: File[]) => void
  files: File[]
}

const NewMessage = ({ messageField, submitting, onSubmit, onFileChange, files }: Props) => {
  const editorRef = React.useRef<EditorHandle>(null)
  const isFormValid = messageField.value || files.length > 0

  const handleSubmit = () => {
    onSubmit()
    editorRef.current?.clear()
    editorRef.current?.clearFiles()
  }

  return (
    <Form onSubmit={handleSubmit} padding="s24">
      <TextEditor
        ref={editorRef}
        onChange={(value) => messageField.set(value)}
        onFiles={onFileChange}
        placeholder={i18n.t('common.start_typing')}
        initialEditorState={{ data: '' }}
      />
      <Form.Buttons>
        <Button disabled={submitting || !isFormValid} submit>
          {i18n.t('bookkeepers.incidence.message.send')}
        </Button>
      </Form.Buttons>
    </Form>
  )
}

export default observer(NewMessage)
